import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CompanionModel } from './companion.model';

@Injectable()
export class CompanionService {

  constructor(private http: HttpClient) { }

  public get(): Observable<CompanionModel> {
    return this.http.get<CompanionModel>(`api/v1/companion`);
  }

  public update(sapCompanion: CompanionModel): Observable<CompanionModel> {
    return this.http.put<CompanionModel>(`api/v1/companion`, JSON.stringify(sapCompanion));
  }

  public updateUrlPath(sapCompanionUrlPath: string): Observable<void> {
    return this.http.patch<void>(`api/v1/companion/urlPath`, JSON.stringify(sapCompanionUrlPath));
  }

}
